var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 4.89a.38.38 0 0 0 0-.51.36.36 0 0 0-.51 0 32.42 32.42 0 0 0-6.39 8c-.46.79.27 1.41.81.77.32-.6.53-.93.88-1.52a32.26 32.26 0 0 1 5.21-6.74Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27.68a.6.6 0 0 0-.15-.48.61.61 0 0 0-.45-.2 14.3 14.3 0 0 0-5.11 1.09 13.85 13.85 0 0 0-6.11 4.73 7.89 7.89 0 0 0-.68 8.33s-1.28 2.72-1.84 4S8 20.38 7.6 21.4a28.81 28.81 0 0 0-2-5.13 19.42 19.42 0 0 0-4.5-5.91.31.31 0 0 0-.44 0 .32.32 0 0 0 0 .44 19 19 0 0 1 4.09 5.86 30.27 30.27 0 0 1 2.15 6.85.61.61 0 0 0 .55.47.59.59 0 0 0 .59-.4c.57-1.67 1.39-3.75 2.39-6 .43-.94.88-1.9 1.37-2.87a4.31 4.31 0 0 0 .79.35 7.58 7.58 0 0 0 2.65.39 8.47 8.47 0 0 0 5.26-2 7.94 7.94 0 0 0 2.76-4.95 13.08 13.08 0 0 0 .12-1.65c.05-2-.38-4.08-.11-6.17Zm-1.09 7.76a6.86 6.86 0 0 1-2.29 4.35 7.5 7.5 0 0 1-4.65 1.87 6.87 6.87 0 0 1-2-.16 3 3 0 0 1-2.18-1.69 7.42 7.42 0 0 1 1.13-6.46A13.26 13.26 0 0 1 18 2.16a14 14 0 0 1 4-.93l0 1c0 2.04.44 4.12.18 6.21Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.aa85453c48315ebe6442ffb3ffed7ebb.svg";
export { ForwardRef as ReactComponent };